import { IItemCampanha, TipoAlvoPrecoCampanha } from "../interfaces/ICampanha";

export interface LinhaPreco {
    key: string;
    categoriaUuid: string;
    categoriaDescricao: string;
    produtoUuid: string;
    produtoDescricao: string;
    tipoAlvo: TipoAlvoPrecoCampanha;
    alvoUuid?: string;
    complementoUuid?: string;
    descricao: string;
    caminho: string;
    precoOriginal: number;
    precoSemDescontoOriginal?: number | null;
}

export function montarLinhasPreco(categorias: any[]): LinhaPreco[] {
    const linhas: LinhaPreco[] = [];

    categorias?.forEach((categoria: any) => {
        categoria.produtos?.forEach((produto: any) => {
            adicionarLinha(linhas, categoria, produto, "PRODUTO", produto, produto.descricao);

            produto.massas?.forEach((massa: any) => adicionarLinha(linhas, categoria, produto, "MASSA", massa, `${produto.descricao} / Massa / ${massa.descricao}`));
            produto.bordas?.forEach((borda: any) => adicionarLinha(linhas, categoria, produto, "BORDA", borda, `${produto.descricao} / Borda / ${borda.descricao}`));
            produto.sabores?.forEach((sabor: any) => adicionarLinha(linhas, categoria, produto, "SABOR", sabor, `${produto.descricao} / Sabor / ${sabor.descricao}`));
            produto.adicionais?.forEach((adicional: any) => adicionarLinha(linhas, categoria, produto, "ADICIONAL", adicional, `${produto.descricao} / Adicional / ${adicional.descricao}`));
            produto.complementos?.forEach((complemento: any) => {
                complemento.itens?.forEach((item: any) => adicionarLinha(linhas, categoria, produto, "ITEM_COMPLEMENTO", item, `${produto.descricao} / ${complemento.descricao} / ${item.descricao}`, complemento.uuid));
            });
            adicionarItensCombo(linhas, categoria, produto, produto.itensCombo ?? [], produto.descricao);
        });
    });

    return linhas.filter(linha => linha.precoOriginal !== undefined && linha.precoOriginal !== null);
}

export function adicionarLinha(linhas: LinhaPreco[], categoria: any, produto: any, tipoAlvo: TipoAlvoPrecoCampanha, alvo: any, caminho: string, complementoUuid?: string) {
    if(alvo?.preco === undefined || alvo?.preco === null) return;
    const alvoUuid = tipoAlvo === "PRODUTO" ? undefined : alvo.uuid;
    const item: LinhaPreco = {
        key: `${categoria.uuid}:${produto.uuid}:${tipoAlvo}:${alvoUuid ?? "PRODUTO"}:${complementoUuid ?? ""}`,
        categoriaUuid: categoria.uuid,
        categoriaDescricao: categoria.descricao,
        produtoUuid: produto.uuid,
        produtoDescricao: produto.descricao,
        tipoAlvo,
        alvoUuid,
        complementoUuid,
        descricao: alvo.descricao ?? produto.descricao,
        caminho,
        precoOriginal: Number(alvo.preco),
        precoSemDescontoOriginal: alvo.precoSemDesconto ?? null
    };
    linhas.push(item);
}

export function adicionarItensCombo(linhas: LinhaPreco[], categoria: any, produto: any, itens: any[], caminhoBase: string) {
    itens?.forEach(item => {
        if(item?.uuid && item?.preco !== undefined) {
            adicionarLinha(linhas, categoria, produto, "ITEM_COMBO", item, `${caminhoBase} / Combo / ${item.descricao ?? item.produto?.descricao ?? item.uuid}`);
        }
        if(item?.produto) {
            adicionarItensCombo(linhas, categoria, produto, [item.produto], `${caminhoBase} / ${item.produto.descricao ?? "Produto"}`);
        }
        Object.keys(item ?? {}).forEach(chave => {
            const valor = item[chave];
            if(Array.isArray(valor)) {
                adicionarItensCombo(linhas, categoria, produto, valor, caminhoBase);
            }
        });
    });
}

export function chaveItem(item: IItemCampanha): string {
    return `${item.categoriaUuid}:${item.produtoUuid}:${item.tipoAlvo}:${item.alvoUuid ?? "PRODUTO"}:${item.complementoUuid ?? ""}`;
}

export function formatarInputData(valor?: string | Date | null): string {
    if(!valor) return "";
    const data = typeof valor === "string" ? new Date(valor) : valor;
    const offset = data.getTimezoneOffset();
    const local = new Date(data.getTime() - offset * 60000);
    return local.toISOString().slice(0, 16);
}

export function formatarDataHumana(valor?: string | Date | null): string {
    if(!valor) return "-";
    return new Date(valor).toLocaleString("pt-BR");
}
